// Notifications, push-player registration (no-op) and the support contact form.

import { defineRoutes, demoError, ids, iso } from '../core';
import type { CreateMultipleNotificationsRequest, CreateNotificationRequest } from '../../types/notification.type';
import type { CreateContactRequest } from '../../types/contact.type';
import { createNotification, markRead, notificationsFor } from '../data/notifications';
import { body } from './errors';

let contactCount = 0;

export const notificationRoutes = defineRoutes([
  [
    'post',
    '/notification/register-player',
    (ctx) => ({
      result: { success: true, message: 'Player registered', player_id: String(body<{ player_id?: string }>(ctx.body).player_id ?? 'demo-player') },
    }),
  ],
  [
    'post',
    '/notification/unregister-player/:playerId',
    (ctx) => ({ result: { success: true, message: 'Player unregistered', player_id: ctx.params.playerId } }),
  ],
  [
    'post',
    '/notification/users',
    (ctx) => {
      const req = body<CreateMultipleNotificationsRequest>(ctx.body);
      const { user_ids, ...rest } = req;
      return { result: (Array.isArray(user_ids) ? user_ids : []).map((user_id) => createNotification({ ...rest, user_id })) };
    },
  ],
  ['post', '/notification', (ctx) => ({ result: createNotification(body<CreateNotificationRequest>(ctx.body)) })],
  ['get', '/notification/:orgId', (ctx) => ({ result: notificationsFor(ctx.params.orgId, ctx.query.limit) })],
  [
    'put',
    '/notification/:orgId/:id/read',
    (ctx) => {
      const n = markRead(ctx.params.orgId, ctx.params.id);
      return n ? { result: n } : demoError(404, 'Notification not found');
    },
  ],
  [
    'post',
    '/contact',
    (ctx) => {
      contactCount += 1;
      const req = body<CreateContactRequest>(ctx.body);
      return {
        result: {
          id: ids.document(contactCount),
          title: req.title ?? '',
          reason: req.reason ?? 'general_inquiry',
          message: req.message ?? '',
          created_at: iso(new Date()),
        },
      };
    },
  ],
]);
